<template>
  <div class="page page_video_play">
    <!-- <div class="tradesmanInfo" v-if="videoDetail != null">
        <div class="attention_status_btn" @click="attention">{{ videoDetail.attention_status == null ? '关注' : '已关注' }}</div>
        <img class="thumb" :src="
                    videoDetail != null && videoDetail.tradesman.thumb != null && videoDetail.tradesman.thumb != ''
                        ? videoDetail.tradesman.thumb
                        : $publicData.defaultTouxiang
                " />
        <div class="tInfos">
            <p class="tradesmanName">{{ videoDetail.tradesman.nickname }}</p>
            <p class="livingNum">{{ videoDetail.count }}人在线</p>
        </div>
    </div> -->
    <div
      class="youku_video"
      v-if="
        videoDetail != null &&
        videoDetail.thurl != '' &&
        videoDetail.thurl != null
      "
      v-html="videoDetail.thurl"
    ></div>
    <div
      class="prism-player video_play"
      :id="playerId"
      :style="playStyle"
    ></div>
    <div class="living_tabs">
      <div class="video_play_title">视频详情</div>
      <div class="describe_tab">
        <div class="tab_content">
          <h3 class="tab_content_title" v-if="videoDetail != null">
            {{ videoDetail.title }}
          </h3>
          <div
            class="living_describe"
            v-if="videoDetail != null"
            v-html="videoDetail.describe"
          ></div>
          <!-- 视频评论 -->
          <!-- 先别删,原评论确实为章节的评论,现客户要求改为整个视频的评论 -->
          <!-- <div class="page_iteminfo">
						<div class="comment">
							<div class="title">视频评论</div>
							<div class="comment_none" v-if="!videoComments">暂无评论，把你想说的评论出来吧～</div>
							<div class="con" v-for="item in videoComments" :key="item.id">
								<div class="con_top clearfix" v-if="item.userdata">
									<div class="f-l thumb">
										<img
											:src="
												item.userdata.thumb
													? item.userdata.thumb
													: $publicData.defaultTouxiang
											"
											alt=""
											class="thumb"
										/>
									</div>
									<div class="f-l con_top_r">
										<span class="user_name">{{
											item.userdata.nickname
										}}</span>
										<span class="time">{{ item.created_at }}</span>
									</div>
								</div>
								<div class="con_nr">
									<div class="yiji_txt">{{ item.content }}</div>
								</div>
							</div>
						</div>
					</div> -->
        </div>
      </div>
    </div>
    <!-- 试看容器 -->
    <template id="endPreviewTemplate">
      <!-- <div class="tips_wrap">
				<div class="tip_success">查看完整视频</div>
				<div class="close_btn">关闭</div>
			</div> -->
    </template>
    <!-- 评论按钮 -->
    <!-- <div class="pinglun_wrap" v-if="is_buy == 0">
			<div class="pinglun" @click="toComment">评论</div>
		</div> -->
    <!-- 视频试看结束弹层 -->
    <div class="pop" v-if="show_pop" @click="goBackToPay">
      试看结束，可购买完整视频
    </div>
  </div>
</template>

<script>
import router from '../../../.././router';
import { LOGOUT, LOGIN } from '../../../.././vuex/mutation_types';
import PageSearch from '../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
  data() {
    return {
      isClient: false,
      token: null,
      playerId: 'aliplayer_' + Math.random().toString(36).substr(2),
      instance: null,
      videoDetail: null,
      playStyle: {
        height: '40vh',
        display: 'none',
      },
      tabActive: 'interaction',
      player: null, // 初始化的播放器
      publicPath: this.$publicData.imgPath,
      videoComments: [],
      pages: {
        page: 1,
        size: 10,
      },
      finished: false, // 评论是否加载完
      loading: true, // 是否加载
      is_charge: this.$route.query.is_charge, // 视频是否需要购买
      is_buy: this.$route.query.is_buy, // 用户是否购买 0未购买 1已购买
      show_pop: false, // 试看结束弹层
      uploadImage: this.$publicData.uploadImage,
    };
  },
  created() {},
  watch: {
    'window.scroll': function (n, o) {
      console.log('页面滚动=======', n);
    },
    // 'loading': function(n,o){
    // 	console.log('监测值的变化',n,o)
    // 	if( !this.finished && this.loading){
    // 		this.getVideoDetail()
    // 	}
    // }
  },
  mounted() {
    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
      this.isClient = true;
      var params = {
        data: {
          // naviBlackStyle: true,
          naviTitle: '视频播放',
          // levitate: true
        },
      };
      this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {});
      //获取用户信息
      var memberParams = {
        data: {
          notCallLogin: 1,
          // 'forceLogin': 1,
        },
      };
      this.$bridge.callhandler(
        'sdjy://member/memberInfo',
        memberParams,
        (data) => {
          if (data.code == 200) {
            this.token = data.result.token;
          } else {
            this.token = '';
          }
          this.getVideoDetail();
        }
      );
      //注册方法，客户端重新进入页面刷新数据
      this.$bridge.registerhandler(
        'sdjy://common/refreshPage',
        (data, responseCallback) => {
          // alert(JSON.stringify(data));
          responseCallback(data);
        }
      );
      // var that = this
      // //注册方法，客户端重新进入页面刷新数据
      // this.$bridge.registerhandler('sdjy://common/leftButtonAction', (data, responseCallback) => {
      //     // alert('sdjy://common/leftButtonAction');
      //     that.player.pause();
      //     // alert(JSON.stringify(data));
      //     responseCallback(data);
      // });
    } else {
      this.isClient = false;
      this.token = this.$store.getters.token;
      this.getVideoDetail();
      // let that = this;
      // document.body.addEventListener(
      //     'touchmove',
      //     function (ev) {
      //         if (that.$route.name == 'video-play') {
      //             ev.preventDefault();
      //         }
      //     }, {
      //         passive: false
      //     }
      // );
      // $("body").on('touchmove',function(ev) {
      //     ev.preventDefault();
      // })
      // this.getShareData()
    }
  },
  methods: {
    getVideoDetail() {
      this.loading = false;
      this.$api.living
        .livevideochapterDetail({
          token: this.token,
          id: this.$route.query.id,
          page: this.pages.page, // this.pages.page
          size: this.pages.size, // this.pages.size
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.videoDetail = res.result.info;
            // 更新视频购买状态
            this.is_charge = res.result.info.livevideo.is_charge;
            this.is_buy = res.result.info.is_buy;
            var comment = res.result.comment;
            if (comment.length != 0) {
              this.videoComments = this.videoComments.concat(comment);
              this.pages.page++;
              this.loading = true;
            } else {
              this.finished = true;
              this.loading = false;
            }
            console.log('完成了吗====', this.finished);
            // this.getShareData()
            // 初始化播放器
            this.setPlayer();
            // 设置title
            window.document.title = this.videoDetail.title;
            // 用户登录状态时,添加观看记录
            this.addVideoLog();
          }
        });
    },
    // 播放器
    setPlayer() {
      var that = this;
      console.log('this.videoDetail', this.videoDetail);
      console.log('this.videoDetail.url', this.videoDetail.url);
      if (!this.videoDetail.url) {
        return;
      }
      console.log('setPlayer');
      if (that.is_charge == 1 && that.is_buy == 0) {
        var time = that.videoDetail.times ? that.videoDetail.times * 60 : 0;
      }
      console.log('111');
      this.playStyle.display = 'block';
      this.instance = new Aliplayer(
        {
          id: this.playerId,
          source: this.$publicData.uploadImage + this.videoDetail.url,
          width: '100%',
          height: this.playStyle.height,
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'hover',
          useH5Prism: true,
          skinLayout: [
            {
              name: 'bigPlayButton',
              align: 'blabs',
              x: 30,
              y: 80,
            },
            {
              name: 'H5Loading',
              align: 'cc',
            },
            {
              name: 'infoDisplay',
            },
            {
              name: 'tooltip',
              align: 'blabs',
              x: 0,
              y: 56,
            },
            {
              name: 'thumbnail',
            },
            {
              name: 'controlBar',
              align: 'blabs',
              x: 0,
              y: 0,
              children: [
                {
                  name: 'progress',
                  align: 'blabs',
                  x: 0,
                  y: 44,
                },
                {
                  name: 'playButton',
                  align: 'tl',
                  x: 15,
                  y: 12,
                },
                {
                  name: 'timeDisplay',
                  align: 'tl',
                  x: 10,
                  y: 7,
                },
                {
                  name: 'fullScreenButton',
                  align: 'tr',
                  x: 10,
                  y: 12,
                },
                {
                  name: 'volume',
                  align: 'tr',
                  x: 5,
                  y: 10,
                },
              ],
            },
          ],
          x5LandscapeAsFullScreen: false,
          // x5_type:'h5',
          showBarTime: 5000,
          controlBarVisibility: 'always',
          x5_fullscreen: true,
          x5_video_position: 'top',
          // "x5_orientation":"landscape",
          components: [
            {
              name: 'PreviewVodComponent',
              type: AliPlayerComponent.PreviewVodComponent,
              /**
               * The preview component has these parameters: previewDuration, previewEndHtml, and previewBarHtml.
               * previewDuration: The length of the preview, in seconds. If you want to disable preview, set this parameter to 0. Make sure that it is set to 0 after the audience purchases the video or becomes a VIP.
               * previewEndHtml: The string shown in the middle of the player after the preview is over. The default is null.
               * previewBarHtml: The string shown in the lower-left corner of the player after the preview is over. The default is null.
               * Note 1: The previewEndHtml and previewBarHtml parameters can be set in the same way as the previewEndHtml parameter in the sample code. You can set the type of a script tag to text/x-template, and then set the previewEndHtml parameter to the ID of the script tag. You can also pass strings to both parameters in the same way as the previewBarHtml parameter in the sample code.
               * Note 2: You can also set a DOM string to the previewEndHtml and previewBarHtml parameters. We recommend that you use ES6 template strings.
               */
              args: [
                time,
                '#endPreviewTemplate',
                `<a href="#" onClick="javascript :history.back(-1);" class="vip_tips">去付费，观看完整视频</a> `,
              ],
            },
          ],
        },
        function (player) {
          that.player = player;
          console.log('The player is created');
          // $('.prism-volume').before("<i class='control_btn'></i>");
          $('video').attr('x5-video-player-type', 'h5');
          // $('.control_btn').on('click', function () {
          //     if (!$('.prism-player').hasClass('fullScreen')) {
          //         $('.prism-player').addClass('fullScreen');
          //         $('.living_tabs').addClass('fullScreen');
          //     } else {
          //         $('.prism-player').removeClass('fullScreen');
          //         $('.living_tabs').removeClass('fullScreen');
          //     }
          // });
          player.on('error', function (e) {
            $('.prism-ErrorMessage').hide();
            player.show_video = true;
          });
          // 自定义试看 -- 弃用,改成阿里云组件了
          // let timer = null
          // timer = setInterval(function(){
          // 	let currentTime = player.getCurrentTime()
          // 	console.log('播放时长=========',currentTime)
          // 	if(currentTime >= 5){
          // 		player.pause()
          // 		player.seek(0)
          // 		that.$toast('试看结束')
          // 		clearInterval(timer)
          // 	}
          // },1000)

          player.on('completeSeek', function (e) {
            let currentTime = player.getCurrentTime();
            if (time && currentTime >= time) {
              player.pause();
              document.querySelector('video').style.display = 'none';
              player.seek(0);
              // that.$toast('试看结束')
              // clearInterval(timer)
            }
          });

          // var close_btn = document.querySelector('.close_btn')
          // console.log('关闭它',)
          // close_btn.addEventListener('click', function() {
          // 	/* Call the closePreviewLayer method to close the dialog box */
          // 	player.getComponent('PreviewVodComponent').closePreviewLayer()
          // })

          // 播放位置发生改变时
          player.on('timeupdate', function () {
            // console.log('触发了+++++++++')
            var currentTime = player.getCurrentTime();
            // console.log('currentTime',currentTime,time)
            if (time && currentTime >= time) {
              player.pause();
              // console.log('11111')
              document.querySelector('video').style.display = 'none';
              // console.log('video',document.querySelector('video'))
              that.show_pop = true;
            }
          });
        }
      );
      // this.playStyle.height="100vh";
    },
    msgTouchStart(e) {
      // console.log('touchstart',e.changedTouches[0]);
      this.startTouch = e.changedTouches[0].pageY;
      this.isTouch = true;
    },
    msgTouchEnd() {
      // console.log('touchend');
      this.isTouch = false;
    },
    msgTouchMove(e) {
      let y = e.changedTouches[0].pageY;
      if ($('.living_tabs').hasClass('fullScreen')) {
        let msgT = $('#msgList1').scrollTop();
        let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
        this.startTouch = y;
        // console.log('move',y,msgT,listScroll,this.startTouch);
        $('#msgList1').scrollTop(listScroll);
      } else {
        let msgT = $('#msgList2').scrollTop();
        let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
        this.startTouch = y;
        // console.log('move',y,msgT,listScroll,this.startTouch);
        $('#msgList2').scrollTop(listScroll);
      }
    },
    msgScroll(e, y) {
      // console.log('滚动了', e.target.scrollTop, e.target.offsetHeight);
      let lH = 0;
      if ($('.living_tabs').hasClass('fullScreen')) {
        lH = $('#msgList1 .interaction_content').height();
      } else {
        lH = $('#msgList2 .interaction_content').height();
      }
      // console.log('msgList:', lH);
      if (e.target.scrollTop + e.target.offsetHeight <= lH - 40) {
        this.goBottom = false;
      } else {
        this.goBottom = true;
      }

      // if ($('.living_tabs').hasClass('fullScreen')) {
      //     if ($('#msgList1 .i_item').length > 3) {
      //         setTimeout(function() {
      //             var len = 0;
      //             $('#msgList1 .i_item').each(function(i) {
      //                 console.log(i, $(this).position().top, $(this).position().top > 0);
      //                 $(this).css({
      //                     opacity: 1
      //                 });
      //                 if ($(this).position().top >= 0) {
      //                     $(this).css({
      //                         opacity: 1 - (10 - len * 3) / 10
      //                     });
      //                     len++;
      //                 } else {
      //                     $(this).css({
      //                         opacity: 0
      //                     });
      //                 }
      //             });
      //         }, 0);
      //     }
      // }
    },
    // 失去焦点时也没高度回弹
    resetWindow() {
      // $(window).scrollTop(0);
      window.scrollTo(-1, 1);
    },
    // 获取分享参数 -- 用于配微信分享
    getShareData() {
      const url = location.href.split('#')[0];
      this.$api.index
        .commonShare({
          url: url,
        })
        .then((res) => {
          if (res.code == 200) {
            var data = res.result;
            this.shareConfig = data;
            console.log('this.shareConfig', this.shareConfig);
            console.log('this.$route', this.$route);
            this.shareFun();
          }
        });
    },
    // 分享
    shareFun() {
      var that = this;
      // console.log('11111111111111')
      wx.config({
        debug: that.shareConfig.debug,
        beta: that.shareConfig.beta,
        jsApiList: that.shareConfig.jsApiList,
        appId: that.shareConfig.appId,
        nonceStr: that.shareConfig.nonceStr, // 随机串
        timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
        signature: that.shareConfig.signature, // 签名
      });
      // console.log('222222222222')
      // console.log('that.videoDetail+1111',that.videoDetail)
      // 分享
      wx.ready(function () {
        const url = location.href.split('#')[0];
        console.log('url', url);
        console.log('that.videoDetail', that.videoDetail);
        var shareData = {
          title: that.videoDetail.title, // 分享标题
          desc: that.videoDetail.describe, // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imageUrl + that.videoDetail.thumb, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
            // alert('成功')
            // console.log('success')
          },
          cancel: function (e) {
            // console.log('e',e)
            // 用户取消分享后执行的回调函数
          },
        };

        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
      });
    },
    // 评论
    toComment() {
      var that = this;
      that.$router.push({
        path: '/video/comment',
        query: {
          id: that.videoDetail.id,
        },
      });
    },
    // 去视频页购买
    goBackToPay() {
      var that = this;
      that.$router.back(-1);
    },
    // 添加观看记录
    addVideoLog() {
      var that = this;
      var params = {
        token: that.token,
        live_videos_id: that.videoDetail.video_id, // 视频ID
        live_videos_chapter_id: that.videoDetail.id, // 视频章节ID
      };
      that.$api.living.addVideoLog(params).then((res) => {
        if (res.code == 200) {
          console.log('已添加观看记录');
        }
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
@import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
.prism-player {
  z-index: 1 !important;
}
/* 跑马灯 */
.van-notice-bar {
  position: fixed;
  top: 0;
  width: 100vw !important;
  height: auto !important;
  /* z-index: 2; */
}
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 40vh;
  display: block;
  width: 100%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 1000;
}
/* .youku_video{
    padding: 1rem 0.4rem 0 0.4rem;
} */
</style>
